var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('main',[_c('router-view',{staticClass:"router"}),_c('site-footer')],1),_c('cookie-consent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }